import MasterApiBase from "./master-api.base";

const SYSTEM_SETTINGS_ENDPOINT = "/settings";

export default class SystemSettingsApi extends MasterApiBase {
	update = (key, data) => {
		return this.axios.put(`${SYSTEM_SETTINGS_ENDPOINT}/${key}`, data);
	};

	bulkUpdate = (data) => {
		return this.axios.put(SYSTEM_SETTINGS_ENDPOINT, data);
	};

	delete = (key) => {
		return this.axios.delete(`${SYSTEM_SETTINGS_ENDPOINT}/${key}`);
	};

	deleteStorePic = () => {
		return this.axios.delete("store/pic");
	};
}
